// Turn a FilterGroup into a nesting-preserving description tree. Each leaf
// rule is rendered to human text via `describeRule`; group logic (AND/OR/NOT)
// is carried through so the UI can show parentheses/connectors faithfully.
// Pure — no React, no state.
import type { FilterGroup, FilterLogic } from "../types/inpact";
import { describeRule, isGroup } from "./filterLogic";

export type DescribedNode =
  | { kind: "rule"; text: string }
  | { kind: "group"; logic: FilterLogic; children: DescribedNode[] };

export function describeFilterTree(
  group: FilterGroup,
  catalogueLabels?: Record<string, string>,
): DescribedNode {
  return {
    kind: "group",
    logic: group.logic,
    children: group.rules.map((r) =>
      isGroup(r)
        ? describeFilterTree(r, catalogueLabels)
        : { kind: "rule", text: describeRule(r, catalogueLabels) },
    ),
  };
}
